import { render, staticRenderFns } from "./GenieKioskManagers.vue?vue&type=template&id=33b83682&"
import script from "./GenieKioskManagers.vue?vue&type=script&lang=js&"
export * from "./GenieKioskManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports